import _ from 'underscore';
import { Activity } from 'botframework-directlinejs';
import { DEFAULT_GROUP_TIME } from './constants';
import { shouldDisplayInConversationThread } from './should-display-in-conversation-thread';

interface IActivityGroup {
  key: string;
  activities: Activity[];
}

export interface IMakeActivityGroupsProps {
  activities: Activity[];
  groupTime?: number;
  isTroubleshootingEnabled?: boolean;
  isReportingInsightsEnabled?: boolean;
  isTroubleshootingIntentionDetectionEnabled?: boolean;
}

export function makeActivityGroups(props: IMakeActivityGroupsProps): IActivityGroup[] {
  const {
    activities,
    groupTime = DEFAULT_GROUP_TIME,
    isTroubleshootingEnabled = false,
    isReportingInsightsEnabled = false,
    isTroubleshootingIntentionDetectionEnabled = false,
  } = props;

  // filter to only the activities to display
  const filteredActivities = _.filter(activities, (activity) => shouldDisplayInConversationThread({
    activity,
    isTroubleshootingEnabled,
    isReportingInsightsEnabled,
    isTroubleshootingIntentionDetectionEnabled,
  }));

  const result: IActivityGroup[] = [];
  let i = 0;
  while (i < filteredActivities.length) {
    // start a new group with 1 activity
    const group = [filteredActivities[i]];
    i += 1;

    const groupStartTime = +((group[0] as any).timestamp as string);

    // look for more activities to add to the group
    while (i < filteredActivities.length) {
      const currentActivity = filteredActivities[i];
      const currentTime = +((currentActivity as any).timestamp || '0');

      const diff = currentTime - groupStartTime;
      if (!Number.isNaN(diff) && diff <= groupTime) {
        // current activity is inside the group time window, add it to the existing group
        group.push(currentActivity);
        i += 1;
      } else {
        break;
      }
    }

    result.push({
      key: group[0].id as string,
      activities: group,
    });
  }

  return result;
}
